
import { Navbar, Main, Product, Footer } from "../components";
//import { useAuth } from "../context/authContext";


function Home() {
  //const { user } = useAuth();
  //console.log(user);

  return (
    <>
      <Navbar />
      <Main />
      <Product />
      <Footer />
    </>
  );
}

export default Home;
